var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rulesCombination" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShow && _vm.tabIndex === "0",
            title: _vm.$t("AutomaticRelease.common.combinationTitle"),
            "close-on-click-modal": false,
            "show-close": false,
            width: "1000px"
          }
        },
        [
          _c("div", { staticClass: "app-main-inner-row" }, [
            _c(
              "div",
              { staticStyle: { width: "605px" } },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      "label-width": "150px",
                      model: _vm.form,
                      rules: _vm.validationRules
                    },
                    nativeOn: {
                      submit: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "spacing setStyle",
                        attrs: {
                          label: _vm.$t("AutomaticRelease.dialogRuleName"),
                          prop: "ruleName",
                          "show-message": false
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              "AutomaticRelease.RuleNamePlaceholder"
                            )
                          },
                          model: {
                            value: _vm.form.ruleName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "ruleName", $$v)
                            },
                            expression: "form.ruleName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabIndex === "0",
                            expression: "tabIndex === '0'"
                          }
                        ],
                        staticClass: "spacing",
                        attrs: {
                          label: _vm.$t("AutomaticRelease.selectBranch")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            on: {
                              change: function($event) {
                                return _vm.selectFilterBranch(_vm.form.branchId)
                              }
                            },
                            model: {
                              value: _vm.form.branchId,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "branchId", $$v)
                              },
                              expression: "form.branchId"
                            }
                          },
                          _vm._l(_vm.branchList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.code, value: item.officeId }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "spacing",
                        attrs: {
                          label: _vm.$t("AutomaticRelease.ruleDescription")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              "AutomaticRelease.ruleDescriptionPlaceholder"
                            ),
                            type: "textarea"
                          },
                          model: {
                            value: _vm.form.describe,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "describe", $$v)
                            },
                            expression: "form.describe"
                          }
                        })
                      ],
                      1
                    ),
                    _c("span", { staticClass: "businessTypes" }, [
                      _vm._v(_vm._s(_vm.$t("AutomaticRelease.AnyRuleTitle")))
                    ]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "spacing newColumnRule",
                        attrs: { "label-width": "0" }
                      },
                      _vm._l(_vm.AnyRules, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "newColumn",
                            staticStyle: { width: "300px" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { remote: "", filterable: "" },
                                on: {
                                  change: function($event) {
                                    return _vm.changed("Any", item, index)
                                  }
                                },
                                model: {
                                  value: item.AnyName,
                                  callback: function($$v) {
                                    _vm.$set(item, "AnyName", $$v)
                                  },
                                  expression: "item.AnyName"
                                }
                              },
                              _vm._l(_vm.AnyRuleOptions, function(k) {
                                return _c("el-option", {
                                  key: k.AnyRulesUuid,
                                  attrs: {
                                    label: k.AnyRulesName,
                                    value: k.AnyRulesUuid
                                  }
                                })
                              }),
                              1
                            ),
                            _c("i", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.AnyRules.length > 1 ||
                                    _vm.AllRules.length > 0,
                                  expression:
                                    "AnyRules.length > 1 || AllRules.length > 0"
                                }
                              ],
                              staticClass: "el-icon-minus addIcon",
                              staticStyle: { "margin-left": "10px" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteRule("Any", item, index)
                                }
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.AnyRules.length < _vm.ruleList.length,
                          expression: "AnyRules.length < ruleList.length"
                        }
                      ],
                      staticClass: "el-icon-plus addIcon",
                      staticStyle: { margin: "5px 0 0 125px" },
                      on: {
                        click: function($event) {
                          return _vm.addRule("Any")
                        }
                      }
                    }),
                    _c("span", { staticClass: "businessTypes" }, [
                      _vm._v(_vm._s(_vm.$t("AutomaticRelease.AllRuleTitle")))
                    ]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "spacing newColumnRule",
                        attrs: { "label-width": "0" }
                      },
                      _vm._l(_vm.AllRules, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "newColumn",
                            staticStyle: { width: "300px" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { remote: "", filterable: "" },
                                on: {
                                  change: function($event) {
                                    return _vm.changed("All", item, index)
                                  }
                                },
                                model: {
                                  value: item.AllName,
                                  callback: function($$v) {
                                    _vm.$set(item, "AllName", $$v)
                                  },
                                  expression: "item.AllName"
                                }
                              },
                              _vm._l(_vm.AllRuleOptions, function(k) {
                                return _c("el-option", {
                                  key: k.AllRulesUuid,
                                  attrs: {
                                    label: k.AllRulesName,
                                    value: k.AllRulesUuid
                                  }
                                })
                              }),
                              1
                            ),
                            _c("i", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.AnyRules.length > 0 ||
                                    _vm.AllRules.length > 1,
                                  expression:
                                    "AnyRules.length > 0 || AllRules.length > 1"
                                }
                              ],
                              staticClass: "el-icon-minus addIcon",
                              staticStyle: { "margin-left": "10px" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteRule("All", item, index)
                                }
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.AllRules.length < _vm.ruleList.length,
                          expression: "AllRules.length < ruleList.length"
                        }
                      ],
                      staticClass: "el-icon-plus addIcon",
                      staticStyle: { margin: "5px 0 0 125px" },
                      on: {
                        click: function($event) {
                          return _vm.addRule("All")
                        }
                      }
                    }),
                    _c("span", { staticClass: "businessTypes" }, [
                      _vm._v(
                        _vm._s(_vm.$t("AutomaticRelease.PerformRelatedActions"))
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "action" },
                      [
                        _c("span", { staticClass: "conditions" }, [
                          _vm._v(
                            _vm._s(_vm.$t("AutomaticRelease.meetConditions"))
                          )
                        ]),
                        _c(
                          "el-checkbox",
                          {
                            attrs: {
                              disabled: true,
                              "true-label": 1,
                              "false-label": 0
                            },
                            model: {
                              value: _vm.form.behaviorStateRelease,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "behaviorStateRelease", $$v)
                              },
                              expression: "form.behaviorStateRelease"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("AutomaticRelease.meetConditionsRemind")
                              )
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "action",
                        staticStyle: {
                          display: "flex",
                          "margin-bottom": "15px"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "conditions",
                            staticStyle: {
                              display: "inline-block",
                              "flex-shrink": "0",
                              "white-space": "normal",
                              "word-break": "break-word",
                              "margin-right": "10px"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("AutomaticRelease.dissatisfaction")
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-checkbox-group",
                              {
                                on: {
                                  change: function($event) {
                                    return _vm.statusChange()
                                  }
                                },
                                model: {
                                  value: _vm.checkList,
                                  callback: function($$v) {
                                    _vm.checkList = $$v
                                  },
                                  expression: "checkList"
                                }
                              },
                              [
                                _c("el-checkbox", { attrs: { label: 0 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("AutomaticRelease.runningRules")
                                    )
                                  )
                                ]),
                                _c(
                                  "el-checkbox",
                                  {
                                    staticStyle: { "margin-top": "15px" },
                                    attrs: { label: 1 }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AutomaticRelease.runningRulesRemind"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticStyle: { "margin-left": "50px", color: "#999" } },
                      [
                        _c("p", { staticStyle: { "margin-bottom": "0px" } }, [
                          _vm._v(_vm._s(_vm.$t("AutomaticRelease.remark1")))
                        ]),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "padding-left": "35px",
                              "margin-top": "5px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("AutomaticRelease.remark2")))]
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "customer" }, [
              _c("span", { staticClass: "businessTypes" }, [
                _vm._v(_vm._s(_vm.$t("AutomaticRelease.applicableCustomers")))
              ]),
              _c("p", { staticStyle: { "padding-left": "20px" } }, [
                _vm._v(
                  _vm._s(_vm.$t("AutomaticRelease.applicableCustomersRemind1"))
                )
              ]),
              _c("p", { staticStyle: { "padding-left": "20px" } }, [
                _vm._v(
                  _vm._s(_vm.$t("AutomaticRelease.applicableCustomersRemind2"))
                )
              ]),
              _c(
                "div",
                { staticClass: "conditionsType" },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("AutomaticRelease.conditionType")))
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "450px" },
                      on: { change: _vm.selectCustomer },
                      model: {
                        value: _vm.conditionType,
                        callback: function($$v) {
                          _vm.conditionType = $$v
                        },
                        expression: "conditionType"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("AutomaticRelease.whole"),
                          value: 0
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("AutomaticRelease.blacklist"),
                          value: 1
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("AutomaticRelease.EffectiveList"),
                          value: 2
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.conditionType !== 0,
                      expression: "conditionType !== 0"
                    }
                  ],
                  staticStyle: { margin: "10px 0 0 20px" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addCustomerEvent }
                    },
                    [_vm._v(_vm._s(_vm.$t("AutomaticRelease.add")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "danger" },
                      on: { click: _vm.delCustomEvent }
                    },
                    [_vm._v(_vm._s(_vm.$t("AutomaticRelease.deletes")))]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "10px", width: "350px" } },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "config-module": "2022072601",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.determine } },
                [_vm._v(_vm._s(_vm.$t("AutomaticRelease.common.save")))]
              ),
              _c("el-button", { on: { click: _vm.cancel } }, [
                _vm._v(_vm._s(_vm.$t("AutomaticRelease.common.cancel")))
              ])
            ],
            1
          )
        ]
      ),
      _c("subscribe-port-push-rule-customer-dialog", {
        attrs: {
          title: _vm.$t("SystemMaintenance.SelectCustomer"),
          visible: _vm.ruleViewVisible,
          customers: _vm.portDataSubscribeConfigCompanyList,
          "branch-id": _vm.form.branchId,
          "branch-show": _vm.branchShow
        },
        on: {
          "update:visible": function($event) {
            _vm.ruleViewVisible = $event
          },
          saveCallBack: _vm.saveCallBackFunc,
          close: function($event) {
            _vm.ruleViewVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }